/**
 * Payment types available for drawer component
 * @type {{SUBSCRIPTION_PAYMENT: string, MILESTONE_PAYMENT: string}}
 */
export const DRAWER_PAYMENT_TYPES = {
    MILESTONE_PAYMENT: 'milestones',
    SUBSCRIPTION_PAYMENT: 'subscription'
};
